
const initialFloatRegex = /^\s*[-+]?\d+\.\d+/
const initialIntRegex = /^\s*[-+]?\d+/

const execFirstMatchOrNull = (re) => (obj) => {
  var result = re.exec(obj.toString())
  if (result && result.length > 0) {
    return result[0];
  }
  return null;
}
const initialInt = execFirstMatchOrNull(initialIntRegex)
const initialFloat = execFirstMatchOrNull(initialFloatRegex)

const initialNumber = (obj) => {
  // try to return null if can't parse an initial number
  let ret = null;
  let result = initialFloat(obj);
  if (result !== null) {
    ret = Number.parseFloat(result, 10);
  } else {
    result = initialInt(obj);
    if (result !== null)
      ret = Number.parseInt(result, 10);
  }
  return ret;
}


const initialNumberRemainder = (str) => {
  var pre = initialInt(str);
  if (pre !== null) {
    return str.substring(pre.length);
  }
  pre = initialFloat(str);
  if (pre !== null) {
    return str.substring(pre.length);
  }
};

const MAX_INITIAL_NUMBER_THEN_LEXICAL_DEPTH = 6;

// Initial number, then lexicographic
export const compareInitialNumberThenLexical = (a, b, level = 0) => {
  if (typeof a === 'undefined'
    || typeof b === 'undefined'
    || a === null
    || b === null
    || level > MAX_INITIAL_NUMBER_THEN_LEXICAL_DEPTH)
    return 0;
  const numA = initialNumber(a);
  const numB = initialNumber(b);
  if (numA !== null && numB !== null) {
    if (numA < numB) {
      return -1;
    }
    if (numA > numB) {
      return 1;
    }
      return compareInitialNumberThenLexical(initialNumberRemainder(a), initialNumberRemainder(b), ++level);
  }

  const strA = a.toString();
  const strB = b.toString();
  if (strA < strB) {
    return -1;
  }
  if (strA > strB) {
    return 1;
  }
  return 0
}



